import axios from "axios";

export async function GetHierarchies(hierarchyType) {
  const response = await axios.get(
    `/api/v1.0/hierarchy/getHierarchiesByType/${hierarchyType}/`
  );

  return response.data.hierarchies;
}

export async function AddHierarchy(hierarchy) {
  const response = await axios.put(
    "/api/v1.0/hierarchy/",
    {
      hierarchy: hierarchy
    },
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data.hierarchy;
}

export async function DuplicateHierarchy(existingHierarchyId, hierarchy) {
  const response = await axios.post(
    `/api/v1.0/hierarchy/${existingHierarchyId}/duplicate`,
    hierarchy,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data;
}

export async function DeleteHierarchy(hierarchyId) {
  const response = await axios.delete(`/api/v1.0/hierarchy/${hierarchyId}`, {
    validateStatus: function(status) {
      return true;
    }
  });

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data;
}

export async function GetHierarchyElements(hierarchyId) {
  const response = await axios.get(
    `/api/v1.0/hierarchy/${hierarchyId}/elements`
  );

  return response.data;
}

export async function UpdateHierarchyElement(hierarchy) {
  const response = await axios.post(
    `/api/v1.0/hierarchy/${hierarchy.hierarchyId}/element/${hierarchy.id}`,
    hierarchy,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data;
}

export async function PublishHierarchy(hierarchyTypeId) {
  const response = await axios.put(
    `/api/v1.0/hierarchy/publish/${hierarchyTypeId}`,
    null,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data;
}

export async function CreateHierarchyElement(hierarchyElement) {
  const response = await axios.put(
    `/api/v1.0/hierarchy/${hierarchyElement.hierarchyId}/element/`,
    hierarchyElement,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.status >= 400) {
    throw response.data;
  }

  return response.data;
}

export async function DeleteHierarchyElement(hierarchyElement) {
  const response = await axios.delete(
    `/api/v1.0/hierarchy/${hierarchyElement.hierarchyId}/element/${
      hierarchyElement.id
    }`,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data;
}
